import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, isVaultDataText } from '@onefootprint/core';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import { EncryptedCell } from '@/components';
import Field from '../../../../../field';
export type UsLegalStatusType = {
  di: DataIdentifier;
  entity: Entity;
};
const UsLegalStatus = t0 => {
  const $0 = _c(7);
  const {
    di,
    entity
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "pages.user.vault"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($0[1] !== t) {
    t2 = value => {
      if (isVaultDataDecrypted(value) && isVaultDataText(value)) {
        return <div className="text-body-2 text-primary" data-dd-privacy="mask">{t($ => $.usLegalStatus.status.options[value])}</div>;
      }
      return <EncryptedCell />;
    };
    $0[1] = t;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== di || $0[4] !== entity || $0[5] !== t2) {
    t3 = <Field di={di} entity={entity} renderValue={t2} />;
    $0[3] = di;
    $0[4] = entity;
    $0[5] = t2;
    $0[6] = t3;
  } else {
    t3 = $0[6];
  }
  return t3;
};
export default UsLegalStatus;